var React = require('react');

function BtnForwardInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Homescreen","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"Homescreen-Desktop-Copy-2","transform":"translate(-1224.000000, -282.000000)","stroke":"#FFFFFF","strokeWidth":"3.84"},React.createElement("g",{"id":"btnForward","transform":"translate(1235.000000, 293.000000)"},React.createElement("g",{"id":"scroll-horizontal"},React.createElement("path",{"d":"M-3.24007488e-14,0 L21,21 C22.6561039,22.657165 22.6561039,25.342835 21,27 L-3.24007488e-14,48","id":"Shape"}))))));
}

BtnForwardInline.defaultProps = {"className":"assets-btn-forward","width":"45px","height":"70px","viewBox":"0 0 45 70","version":"1.1"};

module.exports = BtnForwardInline;

BtnForwardInline.default = BtnForwardInline;
